export default __webpack_public_path__ + "static/media/gamestack-login-large.1b8787ae.jpg";